module.exports = __webpack_public_path__ + "static/media/ios-map.3e4eccd0.svg";